export function isConstructorType(type, value) {
  return value.constructor.name.toLowerCase() === type.toLowerCase()
}
